import {
  BannerConfigType,
  CouponVisibilityConfigType,
  DeliveryInfoConfigType,
  OrderSummaryConfigType,
  ThemeColorPaletteType,
  TrustBadgesConfigType
} from './customizeUI'
import { EarnTileCustomiseUiType } from './rewards'

export type PreviewHeaderLogoType = {
  isHidden?: boolean
  height?: number
  maxWidth?: number
  placeholder?: string
  altText?: string
}

export type PreviewSkeletonType = {
  layout: 'row' | 'column'
  justify?: 'start' | 'space-between'
  config: any
}

export type BrandsPageType = {
  brandLogoURL: string
  colorPalette: ThemeColorPaletteType
  loginButtonCTAText: string
  marketingFlagConfig: {
    enableMarketingFlag: boolean
    marketingConsentText: string
  }
}

export type ElementsPageType = {
  orderSummaryConfig: OrderSummaryConfigType
  colorPalette: ThemeColorPaletteType
  trustBadgesConfig: TrustBadgesConfigType
  loginButtonCTAText: string
  OrderSummaryConfig: OrderSummaryConfigType
}

export type LoginPageType = {
  loginBanner: BannerConfigType
  loginButtonCTAText: string
  colorPalette: ThemeColorPaletteType
  loginCouponVisibility: CouponVisibilityConfigType
}

export type CouponsPageType = {
  colorPalette: ThemeColorPaletteType
}

export type AddressPageType = {
  addressBanner: BannerConfigType
  addressButtonCTAText: string
  colorPalette: ThemeColorPaletteType
  addressCouponVisibility: CouponVisibilityConfigType
  deliveryInfoConfig: DeliveryInfoConfigType
}

export type PaymentsPageType = {
  paymentBanner: BannerConfigType
  paymentsCouponVisibility: CouponVisibilityConfigType
}

export type RewardsPageType = {
  creditName: string
  earnMessage: {
    line_1: string
    line_2: string
  }
  earnTileCustomiseUi: EarnTileCustomiseUiType
}

export type PaymentOffersPageType = {
  paymentMethods: UIPreviewPaymentMethodType[]
}

export type CustomizeUIPreviewType =
  | {
      pageType: 'BRAND'
      config: BrandsPageType
    }
  | {
      pageType: 'ELEMENTS'
      config: ElementsPageType
    }
  | {
      pageType: 'LOGIN'
      config: LoginPageType
    }
  | {
      pageType: 'COUPONS'
      config: CouponsPageType
    }
  | {
      pageType: 'ADDRESS'
      config: AddressPageType
    }
  | {
      pageType: 'PAYMENT'
      config: PaymentsPageType
    }

export type UIPreviewType =
  | CustomizeUIPreviewType
  | {
      pageType: 'REWARDS'
      config: RewardsPageType
    }
  | {
      pageType: 'PAYMENT_OFFERS'
      config: PaymentOffersPageType
    }

export enum UIPreviewPaymentMethods {
  UPI = 'UPI',
  CARD = 'CARD',
  NETBANKING = 'NETBANKING',
  WALLET = 'WALLET',
  COD = 'COD',
  EMI = 'EMI',
  PAY_LATER = 'PAY_LATER'
}

export type UIPreviewPaymentMethodType = {
  paymentMethod: UIPreviewPaymentMethods
  discountText: string
}

export type PaymentMethodsUIConfigType = {
  icon: React.ReactNode | any
  type: UIPreviewPaymentMethods
  label: string
}
